var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMp4 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#6880A1",
  fillRule: "evenodd",
  d: "M9 0h7l6 6v15a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16 0v4a2 2 0 0 0 2 2h4z",
  opacity: 0.6
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 8,
  x: 2,
  y: 13,
  fill: "#F7F8FA",
  rx: 2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#6880A1",
  d: "M4 15h1.203l1.02 2.477h.048L7.291 15h1.204v4h-.946v-2.457h-.034l-.965 2.432h-.605l-.966-2.446h-.033V19H4zM9.1 19v-4h1.661q.452 0 .78.176.33.174.508.486.178.31.178.723 0 .414-.182.724-.18.31-.516.479-.336.17-.797.17H9.707v-.762h.844a.8.8 0 0 0 .367-.076q.15-.076.226-.213a.66.66 0 0 0 .077-.322.64.64 0 0 0-.077-.32.5.5 0 0 0-.226-.212.8.8 0 0 0-.367-.074h-.479V19zM12.65 18.336v-.754L14.296 15h.674v1.023h-.391l-.964 1.52v.031H16v.762zm1.94.664v-.895l.02-.33V15h.91v4z"
})));
export default SvgMp4;